module.exports = "/static/assets/1ea640707afb7490fd25bb7b6da8260f.png";